import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableFooter from '@mui/material/TableFooter'
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
// import './applicationTableEmploymentInfo.scss' 


const  ApplicationTablePaymentInfo = ({ applicationData}) => {

  return (
            
    <div className='item'>

        <div className="details">

              
            <div className='detailItem'>
                <span className='itemKey'>Visa Processing Fee:</span>
                <span className='itemValue'>{applicationData.currency === "NGN" ? "₦" : "$"} {applicationData.total}</span>
            </div>

            <div className='detailItem'>
                <span className='itemKey'>Payment Receipt :</span>
                <a href={applicationData.paymentReceiptImage} download>View</a>
            </div>

            {/* <div  style={{display:'flex', flexDirection:'row', justifyContent:'space-between', marginBottom:20, alignItems:'center', gap:20}}>
                
                <div style={{display:'flex', flexDirection:'row', gap:40}}>
                    <span style={{fontWeight:'bold', color:'#00000088'}}> Payment Receipt :</span>
                </div>
                   
                <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                <a href={applicationData.leaveApprovalLetterImage} download>View</a>

                    
                </div>
                  
                   
            </div> */}
            

           
        
        </div>
    </div>
   
  );
}

export default ApplicationTablePaymentInfo